module.exports = function (fox) {
	'use strict';

	require('../stylus/_promo-entry.styl');
};


//////////////////
// WEBPACK FOOTER
// ./dependencies/stylus.js
// module id = 144
// module chunks = 5